module.exports = __webpack_public_path__ + "img/adverse-reaction-banner-icon.2685c1ad.png";